module.exports = __webpack_public_path__ + "static/media/wow_classic.8bc894c7.jpg";